import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Seo } from "@/components/Seo";

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Connexion réussie");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "E-mail ou mot de passe incorrect");
    } finally { setLoading(false); }
  };

  const cls = "w-full rounded-xl border border-line bg-white px-4 py-3 text-ink focus:outline-none focus:ring-2 focus:ring-olive focus:ring-offset-2 focus:ring-offset-sand transition-all";

  return (
    <div className="min-h-screen grid place-items-center bg-sand px-6" data-testid="admin-login-page">
      <Seo title="Espace administrateur — Sandro Services 06" />
      <form onSubmit={submit} className="w-full max-w-md bg-white border border-line rounded-2xl p-8 md:p-10 shadow-soft">
        <img src="/emblem.png" alt="Sandro Services 06" className="h-16 w-auto" />
        <h1 className="mt-6 font-display text-3xl text-forest">Espace administrateur</h1>
        <p className="mt-2 text-sm text-ink-soft">Connectez-vous pour gérer les avis et la galerie.</p>
        <div className="mt-8 space-y-4">
          <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={cls} placeholder="E-mail" />
          <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={cls} placeholder="Mot de passe" />
          <button type="submit" disabled={loading} data-testid="admin-login-btn" className="w-full inline-flex items-center justify-center gap-2 bg-olive text-white rounded-full px-8 py-4 font-semibold hover:bg-olive-hover transition-all disabled:opacity-60">
            {loading && <Loader2 className="animate-spin" size={18} />} Se connecter
          </button>
        </div>
      </form>
    </div>
  );
}
